import styled, { css } from 'styled-components';
import { Spacer } from '@ontruck/orc';

import ShipperOrderTableHeader from './container';

const blockStyles = ({ cellWidth, fullHeight, grow }) => css`
  ${cellWidth &&
  `
    width: ${cellWidth}px;
    min-width: ${cellWidth}px;
  `};
  ${fullHeight &&
  `
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 1.3;
  `}
  ${grow &&
  `
      flex: 1;
    `}
`;

const textStyles = ({ textAlign = 'left' }) => css`
  text-align: ${textAlign};
`;

const orderStyles = ({ order = 'asc', active }) => {
  const borderColor = active ? '#fff' : 'var(--grey700)';

  if (order === 'asc') {
    return css`
      &:after {
        border-width: 0 3px 6px 3px;
        border-bottom-color: ${borderColor};
      }
    `;
  }

  if (order === 'desc') {
    return css`
      &:after {
        border-width: 6px 3px 0 3px;
        border-top-color: ${borderColor};
      }
    `;
  }

  return '';
};

const sortableStyles = ({ textAlign, sortable }) =>
  sortable &&
  css`
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    border-radius: 2px 2px 0 0;

    ${textAlign === 'right' && 'justify-content: flex-end;'}
    ${textAlign === 'left' && 'justify-content: flex-start;'}
    ${textAlign === 'center' && 'justify-content: center;'}

    &:after {
      content: '';
      width: 0;
      height: 0;
      border-style: solid;
      margin-left: 0.5rem;
      margin-right: 0.5rem;
      border-color: transparent;
    }

    ${orderStyles}
  `;
const sortableActiveStyles = ({ active, sortable }) =>
  active &&
  sortable &&
  css`
    background: var(--grey700);
    color: #fff;
  `;

const StyledHeaderCell = styled(Spacer).attrs(() => ({
  mRight: 'S',
}))`
  font-size: ${(props) => props.theme.base.textSizes.M};
  color: var(--grey700);
  padding-top: 0.4rem;

  ${blockStyles}
  ${textStyles}

  ${sortableStyles}
  ${sortableActiveStyles}
`;

export default styled(ShipperOrderTableHeader)`
  display: flex;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
`;

export { StyledHeaderCell };
